<template>
    <div class="e-btn-language-container">
        <b-btn v-if="languages.length <= 2" @click="toggleLanguage()" class="e-btn-language" v-bind="$props"
            v-on="$listeners" :size="size" :variant="variant" v-b-tooltip
            :title="'Change language|Changer de langue' | tr">
            <img class="flag" :class="{ 'small-flag': size === 'sm' }" v-if="currentLanguage.flag"
                :src="currentLanguage.flag" />
            <img class="flag" :class="{ 'small-flag': size === 'sm' }" v-else
                :src="getPublicIcon('flags/united-states')" />
            <template v-if="showLabel">
                <span class="label mb-0">{{ currentLanguage.name }}</span>
            </template>
            <i class="fas fa-caret-down fa-xs"></i>
        </b-btn>

        <b-dropdown v-else class="select-language h-100 e-btn-language" v-bind="$props" v-on="$listeners"
            :size="showLabel ? size : 'md'" :variant="variant" no-caret>
            <template #button-content>
                <img class="flag" :class="{ 'small-flag': size === 'sm' }" :src="currentLanguage.flag" />
                <span v-if="showLabel" class="label ml-2 mb-0 d-none d-md-inline">{{ currentLanguage.name }}</span>
                <i class="fas fa-caret-down fa-xs" />
            </template>

            <b-dropdown-item v-for="lang in languages" :key="lang.locale" @click="selectLanguage(lang)">
                <div class="d-flex align-items-center px-3 w-100">
                    <img class="flag" :src="lang.flag" />
                    <div class="ml-2">{{ lang.name }}</div>
                    <div class="small ml-auto pl-4">{{ lang.locale }}</div>
                </div>
            </b-dropdown-item>
        </b-dropdown>
    </div>
</template>

<script>
import { getSupportedLocales, getLanguageObject } from '@/../vue-components/helpers/I18nPluginHelper.js';

export default {
    name: `e-btn-language`,
    props: {
        value: { type: String },
        variant: { type: String, default: `light` },
        size: { type: String },
        block: { type: Boolean },
        showLabel: { type: Boolean },
        locales: { type: Array }
    },
    computed: {
        currentLanguage: {
            get() {
                // Convert string locale to language object
                return getLanguageObject(this.value);
            },
            set(lang) {
                // Emit the locale string, not the object
                this.$emit(`input`, lang.locale);
            }
        },
        languages() {
            const supported = getSupportedLocales();

            // Try to get locales from prop, cmsWebsite, or fallback to ['en', 'fr']
            const cmsLangs = this.locales || this.cmsWebsite?.settings?.languages || [`en`, `fr`];

            return supported.filter(loc => cmsLangs.includes(loc.locale));
        }
    },
    methods: {
        toggleLanguage() {
            if (this.languages.length <= 2) {
                const first = this.languages[0];
                const second = this.languages[1];

                if (this.currentLanguage.locale === first.locale) {
                    this.currentLanguage = second;
                } else {
                    this.currentLanguage = first;
                }
            }
        },
        selectLanguage(lang) {
            this.currentLanguage = lang;
        }
    }
}
</script>

<style lang="scss" scoped>
.e-btn-language-container {
    display: flex;
}

.e-btn-language {
    position: relative;
    display: flex;
    align-items: center;
    gap: 3px;

    .flag {
        min-width: 24px;
        max-width: 24px;
        width: 24px;
        height: 16px;
        min-height: 16px;
        max-height: 16px;
        border-radius: 2px;
        overflow: hidden;
        object-fit: cover;
    }

    .small-flag {
        width: 20px;
        height: 20px;
    }

    .fa-caret-down {
        position: absolute;
        bottom: 6px;
        right: 2px;
    }

    .label+.fa-caret-down {
        position: relative;
        right: 0;
        bottom: 0;
    }
}

:deep(.select-language) {
    .dropdown-item {
        min-width: 0 !important;
    }

    .flag {
        min-width: 24px;
        max-width: 24px;
        width: 24px;
        height: 16px;
        min-height: 16px;
        max-height: 16px;
        border-radius: 2px;
        overflow: hidden;
        object-fit: cover;
    }

    .dropdown-toggle {
        display: flex;
        align-items: center;
        height: 100%;
        border-top-left-radius: 4px !important;
        border-bottom-left-radius: 4px !important;
    }
}
</style>
